import React from "react";
import { Container } from "reactstrap";
import { appVersion } from '../../settings/shared/constants';
// used for making the prop types of this component
import PropTypes from "prop-types";

class Footer extends React.Component {
 
  getYear() {
    return new Date().getFullYear();
  }

  render() {
    return (
      <div className="fixed-bottom">
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid}>
          {/* <nav>
            <ul>
              <li>
                <a
                  href="https://www.creative-tim.com?ref=nudr-footer"
                  className="mr-4-px"
                  target="_blank"
                >
                  Creative Tim
                </a>
              </li>
              <li>
                <a
                  href="https://presentation.creative-tim.com?ref=nudr-footer"
                  className="mr-4-px"
                  target="_blank"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="https://blog.creative-tim.com?ref=nudr-footer"
                  target="_blank"
                >
                  Blog
                </a>
              </li>
            </ul>
          </nav>
          */}
          <div className="copyright">
            &copy; {this.getYear()}, <a href="https://decisionfacts.ai/" target="_blank" rel="noreferrer">
            DecisionFacts
            </a>
            . Version{" "}
            <a
              href="# "
              target="_blank"
              rel="noreferrer"
            >
              {appVersion}
            </a>
            .
            &nbsp;

            <a
              href="https://www.privacypolicies.com/live/4ad7ef9a-a5d3-42de-9010-a093861068eb"
              target="_blank"
              rel="noreferrer"
            >
            Privacy Policy
            </a>
&nbsp;
|
&nbsp;
<a
              href="https://www.privacypolicies.com/live/b75c0e79-3893-4c51-aaab-f67a7eff998b"
              target="_blank"
              rel="noreferrer"
            >
           Terms
            </a>

          </div>

        </Container>
      </footer>
      </div>
    );
  }
}

Footer.defaultProps = {
  default: false,
  fluid: false
};

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool
};

export default Footer;
